import {flip, merge, partialRight} from "ramda";

export const defaults = flip(merge)
export const withDefaultMealTypes = partialRight(defaults, [{
    breakfast: [],
    dinner: [],
    supper: []
}])
